(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PharmacyDialogController', PharmacyDialogController);

    PharmacyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pharmacy'];

    function PharmacyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pharmacy) {
        var vm = this;

        vm.pharmacy = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pharmacy.id !== null) {
                Pharmacy.update(vm.pharmacy, onSaveSuccess, onSaveError);
            } else {
                Pharmacy.save(vm.pharmacy, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:pharmacyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();
